<template>
  <v-dialog v-model="dialog" max-width="1100" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Validate Bomlist</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              hide-default-footer
              show-expand
              :expanded.sync="expanded"
              item-key="productId"
            >
              <template v-slot:item.no="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:item.count="{ item }">
                {{ item.items.length }}
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-simple-table class="my-5">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center light-blue lighten-2 font-weight-black">
                            No
                          </th>
                          <th class="text-center light-blue lighten-2 font-weight-black">
                            Product ID
                          </th>
                          <th class="text-center light-blue lighten-2 font-weight-black">
                            Part Number
                          </th>
                          <th class="text-left light-blue lighten-2 font-weight-black">
                            Remark
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(x, index) in item.items" :key="index + 'a'">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">{{ x.productId }}</td>
                          <td class="text-center">{{ x.partNumber }}</td>
                          <td>{{ x.remark }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-alert shaped prominent :type="problems > 0 ? 'warning' : 'success'">
              <div>Peringatan !!</div>
              <div>ada {{ problems }} masalah pada bom list terkait.</div>
              <div>anda tetap bisa melanjutkan untuk save tanpa melihat detail masalah.</div>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save" class="mr-2">
          Save
        </v-btn>
        <v-btn color="error" text @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-validate-bomlist",
  props: {
    dialog: Boolean,
    items: Array,
  },
  computed: {
    problems() {
      let data = 0;
      this.items.forEach(x => {
        data = data + x.items.length;
      });
      return data;
    },
  },
  data() {
    return {
      expanded: [],
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Product ID",
          value: "productId",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "Part Number",
          value: "partNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "DO ID",
          value: "doId",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "DO Number",
          value: "doNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "RFS ID",
          value: "rfsId",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "RFS Number",
          value: "rfsNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
        {
          id: 2,
          text: "Count Problem",
          value: "count",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
          align: "center",
        },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>

<style></style>
